import React, { useEffect, useState } from 'react';
import { Link } from 'react-router-dom';
import AxiosClient from '../../assets/AxiosClient';
import { useStateContext } from '../../Contexts/ContextProvider';
import ConferenceDropdown from '../../Forms/ConferenceDropdown';
import { DataTable, PageHeader, PageToolbar } from '../../componants/Workspace';

const Sessions = () => {
  const { SetNotification } = useStateContext();
  const [sessions, setSessions] = useState([]);
  const [conferenceId, setConferenceId] = useState(null);
  const [loading, setLoading] = useState(false);

  const fetchData = async (cid) => {
    if (!cid) {
      setSessions([]);
      return;
    }
    setLoading(true);
    try {
      const response = await AxiosClient.get('/sessions', {
        params: { conference_id: cid },
      });
      setSessions(response.data);
    } catch (error) {
      SetNotification('Error fetching sessions', 'danger');
    } finally {
      setLoading(false);
    }
  };

  useEffect(() => {
    if (conferenceId) fetchData(conferenceId);
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [conferenceId]);

  const handleDelete = async (id) => {
    if (!window.confirm('Are you sure you want to delete this session?')) return;
    try {
      await AxiosClient.delete(`/sessions/${id}`);
      SetNotification('Session deleted successfully', 'success');
      setSessions((prev) => prev.filter((s) => s.id !== id));
    } catch (error) {
      SetNotification('Error deleting session', 'danger');
    }
  };

  return (
    <>
      <PageHeader
        title="Sessions"
        description="Manage sessions, schedules, and live activity."
        actions={(
          <Link className="btn btn-primary" to="./Add">
            <i className="material-icons" aria-hidden="true">add</i>
            Add session
          </Link>
        )}
      />
      <PageToolbar filters={<ConferenceDropdown conferenceId={conferenceId} setConferenceId={setConferenceId} />} />
      {!conferenceId ? (
        <div className="workspace-empty">Select a conference to view its sessions.</div>
      ) : loading ? (
        <div className="workspace-loading">Loading sessions...</div>
      ) : (
        <DataTable>
            <thead>
              <tr>
                <th>Title</th>
                <th>Start</th>
                <th>End</th>
                <th>Active</th>
                <th>Actions</th>
              </tr>
            </thead>
            <tbody>
              {sessions.length === 0 && (
                <tr>
                  <td colSpan="5" className="text-center">No sessions found</td>
                </tr>
              )}
              {sessions.map((s) => (
                <tr key={s.id}>
                  <td>{s.title}</td>
                  <td>{s.start_time || '-'}</td>
                  <td>{s.end_time || '-'}</td>
                  <td>{s.is_active ? 'Yes' : 'No'}</td>
                  <td>
                    <Link to={`./${s.id}`} className="btn btn-info m-1">View</Link>
                    <Link to={`./Edite/${s.id}`} className="btn btn-dark m-1">Edit</Link>
                    <button
                      className="btn btn-danger m-1"
                      onClick={() => handleDelete(s.id)}
                    >
                      Delete
                    </button>
                  </td>
                </tr>
              ))}
            </tbody>
        </DataTable>
      )}
    </>
  );
};

export default Sessions;
